import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IonItemGroup, IonHeader, ModalController, AlertController, NavController } from '@ionic/angular';
import { IonInfiniteScroll, ActionSheetController } from '@ionic/angular';
import { I18ConfigService } from 'src/app/services/shared/I18-config.service';
import { ProductListService } from 'src/app/services/retail/product-list.service';
import { ProductListAPIResponse, ProductList } from 'src/app/models/product-list';
import { CartService } from 'src/app/services/cart/cart.service';
import { RetailCartService } from 'src/app/services/retail/retail-cart.service';
import { LoaderService } from 'src/app/services/loader/loader.service';
import { SeoService } from 'src/app/services/seo.service';
import { SlugifyPipe } from 'src/app/pipes/slugify.pipe';


@Component({
  selector: 'app-products-list',
  templateUrl: './products-list.page.html',
  styleUrls: ['./products-list.page.scss'],
})
export class ProductsListPage implements OnInit {

  locationId: number;
  showQuantButton: number;
  storeId: number;
  storeName: string;
  currencyCode: string;
  pageNo: number;
  productsList: ProductList[];
  noData: number;
  totalQuantity: number;
  totalPrice: number;
  query: string;
  isAsp: boolean;
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  // tslint:disable-next-line: max-line-length
  constructor(private seoService: SeoService, private activatedRoute: ActivatedRoute, private i18ConfigService: I18ConfigService, private productlistService: ProductListService, private cartService: CartService, private loaderService: LoaderService, private retailCartService: RetailCartService, private slugifyPipe: SlugifyPipe, private navControl: NavController) {
    this.currencyCode = i18ConfigService.getCurrency();
  }

  ngOnInit() {
  }
  ionViewDidEnter() {
    this.isAsp = false;
    if (localStorage.getItem('pid') === 'asp') {
      this.isAsp = true;
    }
    this.locationId = this.activatedRoute.snapshot.params.loc;
    this.storeId = this.activatedRoute.snapshot.params.storeId;
    this.query = this.activatedRoute.snapshot.queryParamMap.get('q');
    // this.storeName = this.activatedRoute.snapshot.params.storeName;
    this.seoService.updatePageTitle(this.storeName + 'productlist');
    this.showQuantButton = 0;
    this.totalQuantity = 0;
    this.totalPrice = 0;
    this.initPageState();
    if (this.locationId && this.storeId) {
      this.productlistService.getProductsByStoreId(this.storeId, this.pageNo, this.locationId, '').subscribe((response: ProductListAPIResponse) => {
        this.storeName = response.storeName || 'Products';
        this.updatePageState(response, response.productList);
        if (response.cartDetails) {
          response.cartDetails.forEach(element => {
            this.totalQuantity += element.quantity;
            this.totalPrice += element.price * element.quantity;
            this.showQuantButton = 1;
          });
        }
      });
    } else {
      // declare incomplete/incorrect request
    }
  }
  initPageState() {
    this.pageNo = 1;
    this.noData = 0;
    this.productsList = [];
    this.totalQuantity = 0;
    this.totalPrice = 0;
  }
  updatePageState(response: ProductListAPIResponse, productData: any[]) {
    if (!response.productList || productData.length === 0) {
      this.noData = 1;
      return;
    }
    this.storeName = response.storeName;
    this.productsList = productData;
    // console.log(this.productsList.length);

    if (this.productsList.length < this.productlistService.apiParams.perpage) {
      if (this.infiniteScroll && !this.infiniteScroll.disabled) {
        this.infiniteScroll.disabled = true;
      }
    } else {
      if (this.infiniteScroll && this.infiniteScroll.disabled) {
        this.infiniteScroll.disabled = false;
      }
    }

  }

  getNextPage(event) {
    let totalProductCount: number;
    this.pageNo++;
    this.productlistService.getProductsByStoreId(this.storeId, this.pageNo, this.locationId, '').subscribe((response: ProductListAPIResponse) => {
      this.updatePageState(response, this.productsList.concat(response.productList));
      totalProductCount = response.productList.length;
      event.target.complete();
      if (this.productsList.length === totalProductCount) {
        event.target.disabled = true;
      } else {
        event.target.disabled = false;
      }
    });
  }

  filterData(event) {

    if (event.key === 'Enter') {
      this.initPageState();
      this.productlistService.getProductsByStoreId(this.storeId, this.pageNo, this.locationId, this.query).subscribe((response: ProductListAPIResponse) => {
        this.storeName = response.storeName || 'Products';
        this.updatePageState(response, response.productList);
        if (response.cartDetails) {
          response.cartDetails.forEach(element => {
            this.totalQuantity += element.quantity;
            this.totalPrice += element.price * element.quantity;
            this.showQuantButton = 1;
          });
        }
      });
    }
  }

  onClear($event) {
    this.productlistService.getProductsByStoreId(this.storeId, this.pageNo, this.locationId,'').subscribe((response: ProductListAPIResponse) => {
      this.storeName = response.storeName || 'Products';
      this.updatePageState(response, response.productList);
      if (response.cartDetails) {
        response.cartDetails.forEach(element => {
          this.totalQuantity += element.quantity;
          this.totalPrice += element.price * element.quantity;
          this.showQuantButton = 1;
        });
      }
    });
  }

}
